import React, { Component } from "react";
import {Row, Col} from 'reactstrap';
import {mapType, trim_str} from '../../../../utils/constants';
import MatchColumn from './MatchColumn/MatchColumn'; 
import Actions from '../Actions/Actions';
import '../../OrganizationSetup.css';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flatten';
import filter from 'lodash/filter';
import uniqBy from 'lodash/uniqBy';
import {deepClone} from './../../../../utils/copyObject';
import concat from 'lodash/concat';
export default class MatchColumns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matchedColumns: concat(this.props.matchedColumns),
      error: false,
      errorMessage: '',
      allowMoreColumnsMatch: this.props.allowMoreColumnsMatch
    }
  }

  componentDidMount() {
    
    window.scrollTo(0, 0);
  }

  handleMatchColumn = (matchedColumn,value) => {
    let {matchedColumns, allowMoreColumnsMatch} = {...this.state};
    matchedColumns = uniqBy(matchedColumns, 'csvField');
    if(this.props.showDropdown && this.props.type === mapType.positions) {
      const i = findIndex(matchedColumns,{csvField : matchedColumn});
      // const i = findIndex(matchedColumns, (c) => c.csvField, {csvField : matchedColumn});
      // console.log('inside--', i)
      if(i > -1) {
        if(value&&value.length>0) {
           if(matchedColumns.length === 2){
             this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
           } else {
            matchedColumns.splice(i,1,{csvField : matchedColumn, value : value});
           }
        } else {
          matchedColumns.splice(i,1);
        }
      } else {
        if(matchedColumns.length === 1){
          // console.log(value,"--ln 48---", matchedColumns)

          if(matchedColumn!==matchedColumns[0].value.label){
            matchedColumns.push({csvField : matchedColumn, value : value});
          }

            if(matchedColumns[0].value.length === 1){
              // If occupation or seniority already matched
              // console.log(matchedColumns[0].value, '--v---', value)

              // matchedColumns.map(e=> {

              //   e.label === value.label?  this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'}):  matchedColumns.push({csvField : matchedColumn, value : value});
              
              // })
                if(value.label === matchedColumns[0].value.label){
                  this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
                } else {
                  matchedColumns.map(e=>console.log(e.csvField))
                  // console.log(matchedColumns)
                  matchedColumns.push({csvField : matchedColumn, value : value});
                  // console.log("after")
                  matchedColumns = uniqBy(matchedColumns, 'csvField')
                }
            } else if(matchedColumns.value){
              // console.log("matched ----- ", matchedColumns)
              // console.log(matchedColumn, '----',value,'--matched---', matchedColumns.value)
              if(value.label === matchedColumns.value.label){
                matchedColumns.splice(i,1,{csvField : matchedColumn, value : value});
                // this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
              } else {
                matchedColumns.push({csvField : matchedColumn, value : value});
                matchedColumns = uniqBy(matchedColumns, 'csvField')
              }
              // if (matchedColumns.value.length === 2){
              //   this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
              // }
              // if(matchedColumns[0].value.length === 2){
              //   this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
              // }
            }
        } else if(matchedColumns.length === 2) {
          // console.log(value,"--ln 48---", matchedColumns)

          this.setState({matchedColumns, error: true, errorMessage: 'To match this column, unmatch another one first.'});
        } else {
          matchedColumns.push({csvField : matchedColumn, value : value});
          // console.log(value,"--ln 48---", matchedColumns)
          matchedColumns = uniqBy(matchedColumns, 'csvField')
        }
      }
      this.setState({matchedColumns : matchedColumns, error:false, errorMessage : ''});
    } else {
      if(allowMoreColumnsMatch) {
        if(this.props.type === mapType.uploadEmployeeDataCsv) {
          const i = findIndex(matchedColumns,{csvField : matchedColumn});
          if(i > -1) {
            matchedColumns.splice(i,1,{csvField : matchedColumn, value : value});
            // matchedColumns.push({csvField : matchedColumn, value : value});
          } else {
            matchedColumns.push({csvField : matchedColumn, value : value});
            matchedColumns = uniqBy(matchedColumns, 'csvField')
          }
          matchedColumns = matchedColumns.filter((o) => o.value);
        } else {
          matchedColumns = [...matchedColumns, matchedColumn];
        }
        this.setState({matchedColumns, error: false, errorMessage: ''});
      } else {
        if(matchedColumns.length===0) {
          matchedColumns = [...matchedColumns, matchedColumn];
          this.setState({matchedColumns, error: false, errorMessage: ''});
        } else {
          this.setState({matchedColumns, error: true, errorMessage: 'To select this column, unselect another one first.'});
        }
      }
    }
    
  }

  handleUnMatchColumn = (unMatchcolumn) => {
    let {matchedColumns} = {...this.state};
    matchedColumns = matchedColumns.filter(matchedColumn => matchedColumn!==unMatchcolumn);
    this.setState({matchedColumns, error: false, errorMessage: ''});
 }

  saveMatchedColumns = () => {
    let {matchedColumns} = {...this.state};

    // console.log(this.props)
    // console.log(matchedColumns)
    // by label in utils/constants.js file ALWAYS gender and office required
    let invalid=[]
    let mapBool = this.props.mappingPositions
    // to handle case for matching on upload vs mapping columns
    let uploadMatch

    if(mapBool){
      uploadMatch=false
    } else {
      matchedColumns.map(e=>{
        // console.log(e)
        if(e.value&&e.value.label){
          uploadMatch = true
          return e.value && e.value.label && e.value.label==="Gender" && e.value.label==="Office"? invalid = []: invalid.push(e.value.label)
        } else {
          return uploadMatch=false
        }
      })
    }

    

    
    // let uploadMatch = this.props.mappingPositions?false:true
    // console.log(uploadMatch, '-in --- ',this.props.mappingPositions)
    // console.log('inv--', invalid)
    // console.log(this.props)
    if(this.props.mappingPositions && matchedColumns.length === 0){
      this.setState({matchedColumns, error: true, errorMessage: 'Please match columns with the information in your .csv that you would like to map.'});
      return
    }

    if(matchedColumns.length === 0 && this.props.mappingPositions!==true) {
      this.setState({matchedColumns, error: true, errorMessage: 'Please select a Gender and Office column'});
    } else if (uploadMatch && (invalid.indexOf("Gender")===-1 || invalid.indexOf("Office")==-1) && this.props.mappingPositions!==true ){
      this.setState({matchedColumns, error: true, errorMessage: 'Please select a Gender and Office column'});
    }else {
      if(!this.props.allowMoreColumnsMatch) {
        this.props.onMatchedColumn(matchedColumns[0]);
      } else {
        this.props.onMatchedColumns(matchedColumns);
      }
    }


  }

 isColumnMatched = (csvField) => {
  let { matchedColumns } = this.state;
  let {type} = this.props;

  if(type === mapType.positions || type === mapType.uploadEmployeeDataCsv) {
    return matchedColumns.filter(matchedColumn => matchedColumn.csvField === csvField).length > 0;
  } else {
    return (matchedColumns.indexOf(csvField) !== -1)
  }
  
 } 
 
 render() {
    let {top, instruction, csvFields, csvData, type, 
      showDropdown,allowDropdownMultiselect,dropdownValues, existingMapping} = this.props;

      // console.log("allData", this.props);
      
    let {matchedColumns, error, errorMessage} = this.state;

    if(type === mapType.uploadEmployeeDataCsv) {
      // console.log('mat--', matchedColumns)
      let values  = matchedColumns && matchedColumns.length>0?matchedColumns.map(e=> (e.value.length!==undefined?e.value.map(c=> c.value) : e.value.value )):null
      let removeList=flatten(values)
      dropdownValues = filter(dropdownValues,(o) => removeList.indexOf(o.value)>-1  ? false : true);
      // console.log('ddVal --- ', dropdownValues)
    }else if (this.props.mappingPositions){
      // console.log("thisisWrongReponse", matchedColumns);
      dropdownValues = filter(dropdownValues,(o) => find(matchedColumns,(c) => {

        if(Array.isArray(c.value)){
          // console.log(o.value,'yes --- ',c.value[0].value)
          // return c.value.map(e=> e.value ==="occupations"? e.value.slice(0, -1) === o.value: e.value === o.value)
          let values  = c.value.map(e=> e.value==="occupations"?e.value="occupation":e.label)
          // console.log(values)
          let removeList=flatten(values)
          // console.log(removeList)
          return removeList.indexOf(o.value)>-1  
        } else {
          return c.value.value ==="occupations"? c.value.value.slice(0, -1) === o.value: c.value.value === o.value 
        }
      }) ? false : true);
    }
    // console.log(dropdownValues, matchedColumns)
    return <div className={top}>
        <Row>
          <Col className="match-column-instruction">{instruction}</Col>
        </Row>
        <Row className="mt40">
          <Col className="columns-match-txt">
          <span>{matchedColumns.length} of {csvFields.length} columns matched</span>
          {error ? <span className="map-gender-err-msg ml10">{errorMessage}</span> : null}  
          </Col>
        </Row>
      <div className="d-flex mt40" style={{ overflowX: 'scroll' }}>
        {csvFields.map((csvField, index) => {
          return <Col sm="4" key={index} style={{paddingLeft: index===0 ? '0px' : '', paddingRight: ((index + 1) % 3 === 0 || (csvFields.length-1 === index)  ) ? '0px': '' }} >
          <MatchColumn
            csvField={csvField}
            csvData={csvData}
            matched={this.isColumnMatched(csvField)}
            onColumnMatch={(value) => this.handleMatchColumn(csvField,value)}
            onColumnUnMatch={() => this.handleUnMatchColumn(csvField)}
            type={type}
            showDropdown={showDropdown}
            dropdownValues={dropdownValues}
            allowDropdownMultiselect={allowDropdownMultiselect}
            dropdownValue={find(matchedColumns,{csvField : csvField})}
            dropdownValuePopulate={find(existingMapping, function(o) { return o.columnName === csvField })}
          />
          </Col>
        })}</div> 
      <Actions
        nextBtnAction={this.saveMatchedColumns}
        nxtBtnIcon="flaticon-next" 
        {...this.props}
      />    
      </div>;
  }
}
